import React, { useEffect } from 'react';
import { useTranslation } from '../../../hooks/useTranslation';
import { TranslationKeyEnum } from '../../../types/constants';
import DynamicPage from '../../DynamicPage';

const Faqs: React.FC = () => {
  const { t } = useTranslation();

  useEffect(() => {
    document.title = t(TranslationKeyEnum.FAQs);
  }, [t]);

  return (
    <div className="flex flex-col max-w-2xl mx-auto">
      <DynamicPage header={false} slug="faq" />
    </div>
  );
};

export default Faqs;
